import React, { useState, useEffect, useContext } from "react"
import { Context as AuthContext } from '../contexts/AuthContext'
import { useParams } from 'react-router-dom'
import {themeColors, radius} from '../constants'
import { useHistory, useAccountingBook } from '../hooks'
import { shareRemittance } from '../utilities/remittanceMessage'
import {
  Separater,
  PageHeader,
} from '../components'

// 設定我的匯款資訊 — edit the current user's own bank-transfer note (per-user)
// and share it (LINE share picker / current group / OS share sheet).
const RemittanceInfoPage = () => {
  const { state: authState } = useContext(AuthContext)
  /* eslint-disable no-unused-vars */
  const [users, accountingBookDetails, loading] = useAccountingBook(authState)
  const history = useHistory()
  const { group_id, accounting_book_id } = useParams()

  const myId = authState.userLineIdToken
  const me = (users || []).find((u) => String(u.id) === String(myId))

  const [value, setValue] = useState('')
  const [saved, setSaved] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (me && me.remittanceInfo != null) {
      setValue(me.remittanceInfo)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [me && me.remittanceInfo])

  const save = () => {
    if (!myId) return Promise.resolve()
    setSaving(true)
    return authState.api.updateUser(group_id, myId, { remittance_info: value })
      .then(() => { setSaved(true); setSaving(false) })
      .catch(() => { setSaving(false) })
  }

  const handleShare = () => {
    // persist the latest edit first, then share it
    save().then(() => {
      shareRemittance({
        creditorName: (me && me.displayName) || '我',
        remittanceInfo: value,
        symbol: accountingBookDetails.currency_symbol || '$',
        exponent: accountingBookDetails.exponent || 0,
      })
    })
  }

  const backUrl = history.routes.accountingBookSettingsPage({ group_id, accounting_book_id })

  return (
    <div style={styles.bg}>
      <PageHeader
        faicon='faChevronLeft'
        onBack={() => history.navigateBack(backUrl)}
        color={themeColors.black}>
        我的匯款資訊
      </PageHeader>
      <Separater style={{ margin: "0px" }}/>

      {loading ? null : (
        <div style={styles.body}>
          <div style={styles.hint}>
            填寫你的銀行帳號等收款資料，要請別人還錢時可以一鍵分享給對方。
          </div>
          <textarea
            style={styles.textarea}
            placeholder={'例：\n國泰世華(013)\n帳號 1234-5678\n戶名 王小明'}
            value={value}
            onChange={(e) => { setValue(e.target.value); setSaved(false) }}
          />
          {saved ? <div style={styles.saved}>已儲存 ✓</div> : null}

          <div style={styles.actions}>
            <button type="button" style={styles.saveBtn} disabled={saving} onClick={save}>
              {saving ? '儲存中…' : '儲存'}
            </button>
            <button
              type="button"
              style={{ ...styles.shareBtn, opacity: value && value.trim().length ? 1 : 0.4 }}
              disabled={!value || !value.trim().length}
              onClick={handleShare}>
              分享我的匯款資訊
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

const styles = {
  bg: {
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    maxHeight: '-webkit-fill-available',
    position: 'relative',
  },
  body: {
    padding: '20px 24px',
  },
  hint: {
    fontSize: '13px',
    color: themeColors.gray600,
    marginBottom: '12px',
    lineHeight: 1.5,
  },
  textarea: {
    width: '100%',
    minHeight: '120px',
    fontSize: '14px',
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid #ddd',
    boxSizing: 'border-box',
    resize: 'vertical',
    fontFamily: 'inherit',
    lineHeight: 1.6,
  },
  saved: {
    fontSize: '12px',
    color: themeColors.green500,
    marginTop: '8px',
  },
  actions: {
    display: 'flex',
    gap: '12px',
    marginTop: '20px',
  },
  saveBtn: {
    flex: '0 0 auto',
    fontSize: '14px',
    fontWeight: 600,
    color: themeColors.gold900,
    background: '#F7EED9',
    border: 'none',
    borderRadius: radius.pill,
    padding: '12px 24px',
    cursor: 'pointer',
  },
  shareBtn: {
    flex: '1 1 auto',
    fontSize: '14px',
    fontWeight: 600,
    color: '#ffffff',
    background: themeColors.green700,
    border: 'none',
    borderRadius: radius.pill,
    padding: '12px 16px',
    cursor: 'pointer',
  },
}

export default RemittanceInfoPage
